<div id="pronto-pago-propuesta">

  <app-card Theme="card-primary background-white">
    <div card-content>
      <app-body Theme="body-normal">
        <div body-content>

          <!-- Estado de carga -->
          <div class="cargando-propuesta" *ngIf="cargando">
            <span class="spinner"></span>
            <app-text Theme="body-normal" Text="Cargando tu propuesta…"></app-text>
          </div>

          <!-- Estado de error: alguna llamada (resumen / cuotas / deuda) falló -->
          <div class="error-propuesta" *ngIf="!cargando && error">
            <app-text Theme="body-normal"
                      Text="No pudimos cargar tu propuesta. Por favor, inténtalo nuevamente."></app-text>
            <app-button Theme="button-primary button-height-xs"
                        [Label]="'<p>Reintentar</p>'"
                        (click)="reintentar()"></app-button>
          </div>

          <ng-container *ngIf="!cargando && !error">

            <!-- Intro -->
            <p class="intro-texto">
              Este es el resumen de tu Plan de Pago: cuánto llevas pagado y cuánto queda por devengar.
            </p>

            <!-- Cabecera: 3 cajas Total / Llevamos / Restantes -->
            <div class="cabecera-cajas">
              <div class="caja">
                <p class="caja__label">Total</p>
                <p class="caja__valor">{{ resumen.totalUf | number:'1.2-20' }} UF</p>
                <p class="caja__sub">{{ resumen.totalCuotas }} cuotas totales</p>
              </div>
              <div class="caja">
                <p class="caja__label">Llevamos</p>
                <p class="caja__valor">{{ resumen.pagadoUf | number:'1.2-20' }} UF</p>
                <p class="caja__sub">{{ resumen.cuotasPagadas }} cuotas pagadas</p>
              </div>
              <div class="caja">
                <p class="caja__label">Restantes</p>
                <p class="caja__valor">{{ resumen.devengarUf | number:'1.2-20' }} UF</p>
                <p class="caja__sub">{{ resumen.cuotasPendientes }} cuotas por pagar</p>
              </div>
            </div>
            <p class="nota-montos" *ngIf="valorUf">
              Montos en UF · Valor UF de referencia $ {{ valorUf | number:'1.2-20' }}
            </p>

            <p class="intro-texto">
              Con tu Pronto Pago puedes recibir en una sola cuota el saldo pendiente, 
              luego de aplicada la tasa de descuento definida por la normativa vigente. 
              Revisa el detalle, elige y acepta tu propuesta.
            </p>

            <!-- Título + stepper -->
            <div class="cabecera-paso">
              <h2 class="titulo-paso">Oferta de Pronto Pago <span class="titulo-paso__sub">| Revisa, elige y acepta</span></h2>
              <ol class="stepper">
                <li class="stepper__paso stepper__paso--activo">
                  <span class="stepper__circulo">1</span>
                  <span class="stepper__label">Oferta</span>
                </li>
                <li class="stepper__linea"></li>
                <li class="stepper__paso">
                  <span class="stepper__circulo">2</span>
                  <span class="stepper__label">Verificación</span>
                </li>
              </ol>
            </div>

            <!-- ¿Qué quieres hacer con tu Pronto Pago? (deuda + combobox de modalidad)
                 Sin deudas no hay nada que compensar: se oculta y se usa "sin compensar". -->
            <div class="eleccion" *ngIf="tieneDeuda">
              <h3 class="eleccion__titulo">¿Qué quieres hacer con tu Pronto Pago?</h3>
              <p class="eleccion__intro">
                Opción de compensar tus deudas previo al Pronto Pago (voluntario), optando al
                beneficio de condonación de intereses y recargos.
              </p>

              <!-- Tabla 1: deuda actual -->
              <p class="eleccion__subtitulo">De acuerdo a nuestros registros, tienes a la fecha la(s) siguiente(s) deuda(s) con Colmena:</p>
              <div class="tabla-scroll">
                <table class="tabla-deuda">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th class="num">Deuda</th>
                      <th class="num">Intereses</th>
                      <th class="num">Recargos</th>
                      <th class="num">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let d of deuda">
                      <tr>
                        <td>
                          <span class="tipo">{{ d.conceptoDeuda }}</span>
                          <button type="button" class="ver-detalle"
                                  [attr.aria-expanded]="estaExpandida(d)"
                                  (click)="toggleDetalleDeuda(d)">
                            {{ estaExpandida(d) ? 'ocultar' : 'ver detalle' }}
                          </button>
                        </td>
                        <td class="num">$ {{ d.montoDeudaBrutoClp | number:'1.0-0' }}</td>
                        <td class="num">$ {{ d.montoInteresesClp | number:'1.0-0' }}</td>
                        <td class="num">$ {{ d.montoRecargosClp | number:'1.0-0' }}</td>
                        <td class="num fuerte">$ {{ d.montoDeudaTotalClp | number:'1.0-0' }}</td>
                      </tr>
                      <tr class="fila-detalle" *ngFor="let det of d.detalles" [hidden]="!estaExpandida(d)">
                        <td class="detalle-glosa" colspan="5">{{ det.detalleDeuda }}</td>
                      </tr>
                    </ng-container>
                    <tr class="fila-total">
                      <td>Deuda total</td>
                      <td class="num">$ {{ deudaBrutoTotalClp | number:'1.0-0' }}</td>
                      <td class="num">$ {{ deudaInteresesTotalClp | number:'1.0-0' }}</td>
                      <td class="num">$ {{ deudaRecargosTotalClp | number:'1.0-0' }}</td>
                      <td class="num">$ {{ deudaTotalClp | number:'1.0-0' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Tabla 2: deuda a compensar con condonación (solo capital) -->
              <p class="eleccion__subtitulo">
                Si compensas tu(s) deuda(s), obtendrás como beneficio la condonación de intereses y
                recargos generados, quedando tu deuda a compensar así:
              </p>
              <div class="tabla-scroll tabla-scroll--estrecha">
                <table class="tabla-deuda tabla-deuda--beneficio">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th class="num">Deuda</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let d of deuda">
                      <td>{{ d.conceptoDeuda }}</td>
                      <td class="num">$ {{ d.montoDeudaBrutoClp | number:'1.0-0' }}</td>
                    </tr>
                    <tr class="fila-total fila-total--beneficio">
                      <td>Deuda a compensar con beneficio de condonación</td>
                      <td class="num">$ {{ deudaBrutoTotalClp | number:'1.0-0' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Combobox: las dos modalidades -->
              <div class="opciones">
                <button type="button" class="opcion"
                        [class.opcion--activa]="modalidad === 1"
                        (click)="seleccionarModalidad(1)">
                  <span class="opcion__radio"></span>
                  <span class="opcion__texto">
                    <span class="opcion__titulo">Optar por Pronto Pago compensando tu deuda</span>
                    <span class="opcion__desc">
                      <ng-container *ngIf="deudaTotalClp - deudaBrutoTotalClp > 0">
                        Al aceptar la opción de compensar tu deuda, estarás ahorrando
                        <strong>$ {{ deudaTotalClp-deudaBrutoTotalClp | number:'1.0-0' }}</strong>
                        (${{ deudaTotalClp | number:'1.0-0' }} - ${{ deudaBrutoTotalClp | number:'1.0-0' }}).
                      </ng-container>El Pronto Pago se aplicará sobre el saldo restante, con el respectivo descuento
                      por pago anticipado.
                    </span>
                  </span>
                </button>

                <button type="button" class="opcion"
                        [class.opcion--activa]="modalidad === 0"
                        (click)="seleccionarModalidad(0)">
                  <span class="opcion__radio"></span>
                  <span class="opcion__texto">
                    <span class="opcion__titulo">Solicitar Pronto Pago sin compensar tu deuda</span>
                    <span class="opcion__desc">Con esta opción mantienes tus deudas con la Isapre,
                      renuncias al beneficio de condonación de intereses y recargos, ejecutándose el
                      Pronto Pago sobre el saldo de restituciones TFU con el respectivo descuento por pago
                      anticipado.</span>
                  </span>
                </button>
              </div>
            </div>

            <!-- Placeholder: aún no se elige modalidad -->
            <div class="placeholder" *ngIf="modalidad === null">
              <p>Elige una opción arriba para ver el detalle de tu propuesta.</p>
            </div>

            <!-- Bloque inferior: detalle de cuotas + resumen de la oferta -->
            <div class="propuesta-detalle" *ngIf="modalidad !== null">

              <!-- Tabla de cuotas (headers según modalidad) -->
              <div class="tarjeta-cuotas">
                <h3 class="tarjeta-cuotas__titulo">Detalle de las cuotas</h3>
                <p class="tarjeta-cuotas__sub" *ngIf="compensando">
                  Las primeras cuotas compensan tu deuda a valor nominal (sin descuento). 
                  Las cuotas restantes se anticiparán y se les aplicará el descuento por pago anticipado.
                </p>
                <p class="tarjeta-cuotas__sub" *ngIf="!compensando">
                  Cuotas anticipadas y valor en pesos del descuento aplicado.
                </p>

                <div class="tabla-scroll">
                  <table class="tabla-cuotas">
                    <thead>
                      <tr>
                        <th>N° <span>cuota</span></th>
                        <th>Mes <span>cuota</span></th>
                        <th class="num">Deuda pendiente de pago <span>(UF)</span></th>
                        <th class="num">Deuda pendiente de pago <span>($)</span></th>
                        <th class="num">Descuento por pago Anticipado <span>($)</span></th>
                        <th class="num">Total a {{ compensando ? 'pagar' : 'recibir' }} <span>($)</span></th>
                        <th>Tipo de pago</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let c of cuotasPagina">
                        <td class="td-num">{{ c.numCuota }}</td>
                        <td class="td-mes">{{ c.periodoCuota }}</td>
                        <td class="num fuerte">{{ c.cantidadDevengarUf | number:'1.2-20' }} UF</td>
                        <td class="num">$ {{ c.montoDevengarClp | number:'1.2-2' }}</td>
                        <td class="num">
                          <span *ngIf="c.montoDescuentoClp > 0" class="descuento">− $ {{ c.montoDescuentoClp | number:'1.0-0' }}</span>
                          <span *ngIf="c.montoDescuentoClp === 0" class="vacio">—</span>
                        </td>
                        <td class="num fuerte">
                          <span *ngIf="c.glsTipoPago === 'Pago anticipado'">$ {{ c.montoNetoDevengado | number:'1.2-2' }}</span>
                          <span *ngIf="c.glsTipoPago === 'Compensación'" class="vacio">—</span>
                        </td>
                        <td>
                          <span class="badge"
                                [class.badge--anticipado]="c.glsTipoPago === 'Pago anticipado'"
                                [class.badge--compensada]="c.glsTipoPago === 'Compensación'">
                            {{ c.glsTipoPago }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot *ngIf="paginaActual === totalPaginas">
                      <tr class="fila-totales">
                        <td colspan="2" class="td-totales">Totales</td>
                        <td class="num fuerte">{{ totalCuotasUf | number:'1.2-4' }} UF</td>
                        <td class="num">$ {{ montoTotalClp | number:'1.0-0' }}</td>
                        <td class="num" *ngIf="!compensando">
                          <span *ngIf="montoTotalDescuentoSinCompensacionClp > 0" class="descuento">− $ {{ montoTotalDescuentoSinCompensacionClp | number:'1.0-0' }}</span>
                          <span *ngIf="montoTotalDescuentoSinCompensacionClp === 0" class="vacio">—</span>
                        </td>
                        <td class="num" *ngIf="compensando">
                          <span *ngIf="montoTotalDescuentoConCompensacionClp > 0" class="descuento">− $ {{ montoTotalDescuentoConCompensacionClp | number:'1.0-0' }}</span>
                          <span *ngIf="montoTotalDescuentoConCompensacionClp === 0" class="vacio">—</span>
                        </td>
                        <td class="num fuerte" *ngIf="!compensando">$ {{ liquidoSinCompensacionPesos | number:'1.0-0' }}</td>
                        <td class="num fuerte" *ngIf="compensando">$ {{ liquidoConCompensacionPesos | number:'1.0-0' }}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <!-- Paginación -->
                <div class="paginacion" *ngIf="totalPaginas > 1">
                  <p class="paginacion__rango">{{ rangoCuotas }}</p>
                  <div class="paginacion__controles">
                    <button type="button" (click)="irAPagina(1)" [disabled]="paginaActual === 1" aria-label="Primera página">«</button>
                    <button type="button" (click)="irAPagina(paginaActual - 1)" [disabled]="paginaActual === 1" aria-label="Página anterior">‹</button>
                    <button type="button" *ngFor="let p of paginas"
                            [class.activa]="p === paginaActual" (click)="irAPagina(p)">{{ p }}</button>
                    <button type="button" (click)="irAPagina(paginaActual + 1)" [disabled]="paginaActual === totalPaginas" aria-label="Página siguiente">›</button>
                    <button type="button" (click)="irAPagina(totalPaginas)" [disabled]="paginaActual === totalPaginas" aria-label="Última página">»</button>
                  </div>
                </div>
              </div>

              <!-- Resumen de tu oferta (degradado azul) -->
              <div class="resumen-oferta">
                <div class="resumen-oferta__head">
                  <h3>Resumen de tu oferta de Pronto Pago.</h3>
                </div>

                <div class="resumen-oferta__montos">
                  <div class="fila">
                    <span>Deuda pendiente de pago</span>
                    <span class="valor">$ {{ montoTotalClp | number:'1.0-0' }}</span>
                  </div>
                  <div class="fila" *ngIf="compensando">
                    <span>Compensación de deuda</span>
                    <span class="valor">− $ {{ compensaDeudaClp | number:'1.0-0' }}</span>
                  </div>
                  <div class="fila" *ngIf="!compensando">
                    <span>Descuento por pago anticipado</span>
                    <span class="valor">− $ {{ montoTotalDescuentoSinCompensacionClp | number:'1.0-0' }}</span>
                  </div>
                  <div class="fila" *ngIf="compensando">
                    <span>Descuento por pago anticipado</span>
                    <span class="valor">− $ {{ montoTotalDescuentoConCompensacionClp | number:'1.0-0' }}</span>
                  </div>
                  <div class="divisor"></div>
                  <div class="fila fila--liquido" *ngIf="!compensando">
                    <span>Monto a recibir</span>
                    <span class="valor">$ {{ liquidoSinCompensacionPesos | number:'1.0-0' }}</span>
                  </div>
                  <div class="fila fila--liquido" *ngIf="compensando">
                    <span>Monto a recibir</span>
                    <span class="valor">$ {{ liquidoConCompensacionPesos | number:'1.0-0' }}</span>
                  </div>
                </div>

                <p class="resumen-oferta__nota" *ngIf="!compensando && tieneDeuda">
                  Tu deuda de $ {{ deudaBrutoTotalClp | number:'1.0-0' }} seguirá vigente y deberás
                  pagarla por separado.
                </p>

                <div class="divisor divisor--claro"></div>

                <div class="fila">
                  <span>Vigencia de la oferta</span>
                  <span class="valor">hasta {{ resumen.fechaVigenciaOferta }}</span>
                </div>
                <div class="fila">
                  <span>Fecha de pago</span>
                  <span class="valor">{{ resumen.fechaPago }}</span>
                </div>
                <div class="fila">
                  <span>Medio de pago</span>
                  <span class="valor">transferencia a cuenta bancaria registrada o vale vista</span>
                </div>

                <p class="resumen-oferta__cond">Condiciones de tu oferta</p>

                <!-- Documento Acuerdo (obligatorio) — descarga el PDF del Acuerdo según la modalidad -->
                <a class="doc" [class.doc--cargando]="descargandoAcuerdo"
                   (click)="descargarAcuerdo()">
                  <span class="doc__pdf">PDF</span>
                  <span class="doc__texto">
                    <span class="doc__titulo">Acuerdo <span class="doc__chip">Obligatorio</span></span>
                  </span>
                  <span class="doc__accion">
                    {{ descargandoAcuerdo ? 'Descargando…' : (acuerdoDescargado ? 'Descargado' : 'Descargar') }}
                  </span>
                </a>

                <p class="resumen-oferta__hint resumen-oferta__hint--error" *ngIf="errorDescargaAcuerdo">
                  No pudimos descargar el Acuerdo. Vuelve a intentarlo.
                </p>

                <!-- Aceptación -->
                <label class="check-acuerdo" [class.deshabilitado]="!acuerdoDescargado">
                  <input type="checkbox" [(ngModel)]="acuerdoAceptado" [disabled]="!acuerdoDescargado" />
                  <span>Declaro que he leído, comprendido y aceptado el Acuerdo.</span>
                </label>

                <app-button Theme="button-primary"
                            class="boton-aceptar"
                            [class.boton-aceptar--off]="!puedeContinuar"
                            [Label]="'<p>Firmar Acuerdo y Continuar a Verificación</p>'"
                            [IcoSvg]="null"
                            (click)="continuarAVerificacion()"></app-button>

                <p class="resumen-oferta__hint" *ngIf="!acuerdoDescargado">
                  * Primero descarga el Acuerdo para habilitar la firma
                </p>
                <p class="resumen-oferta__voluntario">
                  Es voluntario. Si no aceptas, mantienes íntegro tu derecho a recibir el pago en las cuotas indicadas en tu PPA
                </p>
              </div>

            </div>

          </ng-container>

        </div>
      </app-body>
    </div>
  </app-card>
</div>
